<template>
  <layout-main-inner title="考试详情">
    <div slot="action">
      <button-back />
    </div>
    <layout-card-wrap hasSlot>
      <template slot="title">考试信息</template>
      <!-- <template slot="form">
        <el-button
          type="primary"
          @click="updateitem">
          编辑
        </el-button>
      </template> -->
      <el-form
        v-loading="loading"
        label-position="top"
        label-width="110px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="考试名称：">{{ info.examName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考试科目：">{{ info.subjectName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考试时间：">{{ info.beginTime | dateformat('YYYY-MM-DD HH:mm') }}至{{ info.endTime | dateformat('YYYY-MM-DD HH:mm') }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考卷分数：">
              <span>{{ info.paperName }}</span>，
              <b>总分：</b><span>{{ info.paperScore }}分</span>，
              <b>答题时间：</b><span>{{ info.examMinutes }}分钟</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="info.secondScoreName+'：'">{{ info.secondScore }}分</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="info.thirdScoreName+'：'">{{ info.thirdScore }}分</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="通过分数：">
              <div style="display: flex;">
                <span>考试总分为：<b>{{ info.totalScore }}</b>分，</span>
                <span>得分达到<b>{{ info.passingScore }}</b>分通过</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考试状态：">{{ info.status | examStatusName() }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <exam-reg-info
      v-if="info.id"
      :id="info.id"
      :info="info" />
  </layout-main-inner>
</template>
<script>
import ExamRegInfo from './busi/exam-reg-info.vue'
// import CourseScoreTable from './course-score-table.vue'
export default {
  name: 'ExaminationDetail',
  components: { ExamRegInfo },
  data() {
    return {
      loading: false,
      info: {}
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getcourseexam()
    }
  },
  methods: {
    updateitem() {
      const row = this.info
      this.$refs.score.update({
        id: row.id,
        courseExamName: row.courseExamName,
        examTime: row.examTime,
        queryScoreStatus: row.queryScoreStatus
      })
    },
    getcourseexam() {
      this.loading = true
      this.$$examApi.getexam({ ...this.$route.params })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.info = { ...this.info, ...res.data }
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
